<template>
  <div :id="content.idHTML">
    <!-- tag="div" nécessaire pour accessibilité, éviter div dans un span -->
    <ValidationObserver tag="div">
      <ValidationProvider
        v-slot="validationContext"
        name="optionChoisi"
        :rules="reglesOptions"
        tag="div"
      >
        <fieldset
          :id="idFieldset"
          class="font-radio-btn customRadio radio-general spaceBetweenRadioBtn"
        >
          <div class="row mx-0">
            <template v-for="(item, index) in options">
              <div
                :key="item.value"
                class="align-items-center blanc-bg"
                :class="[
                  content.choixParLigne == 1 ? 'd-flex' : 'd-inline-flex',
                  {
                    'col px-0 text-center': content.format == 'tableau',
                  },
                ]"
              >
                <input
                  :id="item.value"
                  :key="index"
                  v-model="optionChoisi"
                  type="radio"
                  :value="item.value"
                  :name="item.name"
                  class="m-0"
                  :class="{ 'd-none': content.format == 'tableau' }"
                />
                <label
                  :key="item.text"
                  :for="item.value"
                  class="label-input"
                  :class="[
                    { tableau: content.format == 'tableau' },
                    { premier: index == 0 },
                    { dernier: index == options.length - 1 },
                  ]"
                  v-html="item.text"
                />
              </div>
            </template>
          </div>
        </fieldset>
        <ErreurValidation
          id="option-live-feedback"
          :message="validationContext.errors[0]"
        ></ErreurValidation>
      </ValidationProvider>
      <div v-if="content.libAutre !== undefined && selectionAutre === true" class="pt-1">
        <transition name="fade">
          <!-- tag="div" nécessaire pour accessibilité, éviter div dans un span -->
          <ValidationProvider
            v-slot="validationContext"
            ref="validator"
            :mode="customValidation"
            name="optionAutre"
            :rules="reglesAutre"
            tag="div"
          >
            <!-- Si montant autre -->
            <b-form-group v-show="selectionAutre">
              <div v-if="content.type == 'monetaire'" class="row col-6 col-md-4">
                <legend class="texte texte-padding" label-for="optionAutre">
                  {{ content.libAutre }}
                </legend>
                <div class="input-group">
                  <money
                    id="optionAutre"
                    ref="optionAutre"
                    v-model="optionAutre"
                    :aria-label="content.libAutre"
                    maxlength="7"
                    v-bind="$t('vMoneySansDecimales')"
                    class="form-control pb-0 pt-0"
                    :class="{ 'is-invalid': validationContext.errors.length > 0 }"
                    @blur.native="forceValidate()"
                  />
                </div>
              </div>
              <div v-else-if="content.type == 'heure'" class="input-group mb-3">
                <b-form-input
                  :id="content.idHTML + 'optionAutre'"
                  v-model="optionAutre"
                  :type="typeInput"
                  class="form-control pt-0"
                  :class="{
                    'is-invalid': validationContext.errors.length > 0, // Attention si on ne met pas ceci les erreurs n'aparaissent pas pour v-money...
                  }"
                  @blur.native="validationContext.validate()"
                />
                <div class="input-group-append">
                  <span
                    class="input-group-text border-left-0 is-valid"
                    :class="{ 'is-invalid': validationContext.errors.length > 0 }"
                    >h</span
                  >
                </div>
              </div>
              <!-- Utilisé le 'number' pour les limites bien jouer -->
              <div v-else-if="content.type == 'number'" class="d-flex justify-content-end mt-3">
                <div class="">
                  <div class="input-group-limite">
                    <div
                      v-if="$i18n.locale == 'en' && content.unite != 'h'"
                      class="input-group-append-limite"
                    >
                      {{ content.unite }}
                    </div>
                    <money
                      id="optionAutre"
                      ref="optionAutre"
                      v-model="optionAutre"
                      :aria-label="content.libAutre"
                      :maxlength="content.inputLength"
                      autocomplete="off"
                      v-bind="$t('vMoneySansDecimalesDollars')"
                      class="form-control form-control-limite pb-0 pt-0"
                      :class="{ 'is-invalid': validationContext.errors.length > 0 }"
                      @change.native="validateChange()"
                      @blur.native="forceValidateInput()"
                    />
                    <div
                      v-if="$i18n.locale == 'fr' || content.unite == 'h'"
                      class="input-group-append-limite"
                    >
                      {{ content.unite }}
                    </div>
                  </div>
                  <div
                    v-show="validationContext.errors.length == 0"
                    class="info-lib-msg justify-content-end mb-1"
                  >
                    {{ content.minMaxValues.validationMsg }}
                  </div>
                </div>
              </div>
              <b-form-input
                v-else
                :id="content.idHTML + 'optionAutre'"
                v-model="optionAutre"
                :type="typeInput"
                class="form-control pt-0"
                :class="{
                  'is-invalid': validationContext.errors.length > 0, // Attention si on ne met pas ceci les erreurs n'aparaissent pas pour v-money...
                }"
                @blur.native="validationContext.validate()"
              />
              <ErreurValidation
                id="message-limite-depot-invalide"
                :message="validationContext.errors[0]"
                :variables="variablesRemplacement"
                :class="content.type == 'number' ? 'd-flex justify-content-end' : ''"
              ></ErreurValidation>
            </b-form-group>
          </ValidationProvider>
        </transition>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import { VMoney } from 'v-money';

import ErreurValidation from '@/components/formulaire/compte/ErreurValidation';

import { formatNombreEnMonetaire } from '@/helpers/StringHelpers';

export default {
  name: 'GroupeRadio',
  components: { ErreurValidation },
  directives: { money: VMoney },
  props: ['content', 'value', 'validationContext'],

  data() {
    return {
      idFieldset: this._uid,
      options: [],
      validated: false,
      valeurChoix: this.value,
      limiteMaxDepot: this.$store.state.compte.limiteMaxDepot,
      variablesRemplacement: {
        limiteMinDepotHebdo: process.env.VUE_APP_MIN_LIMITE_DEPOT_HEBDO,
        limiteMaxDepotHebdo: process.env.VUE_APP_MAX_LIMITE_DEPOT_HEBDO,
      },
    };
  },
  computed: {
    optionChoisi: {
      get() {
        return this.valeurChoix;
      },
      set(value) {
        this.valeurChoix = value;
        if (value === 0) {
          this.optionAutre = 0;
        }
        this.$emit('input', this.valeurChoix);
      },
    },
    selectionAutre() {
      if (this.optionChoisi === -1) {
        return false;
      }

      if (
        this.optionChoisi == 0 ||
        (this.optionChoisi !== this.options[0].value &&
          this.optionChoisi !== this.options[1].value &&
          this.optionChoisi !== this.options[2].value)
      ) {
        return true;
      }
      return false;
    },
    reglesOptions() {
      // Validation si composant enfant
      if (this.content.validationChoix) {
        return this.content.validationChoix;
      }
      // Validation lorsque utilisé par Magnolia directement
      // Si règles définies dans Magnolia
      if (this.content.reglesChoix) {
        return this.content.reglesChoix;
      }
      // Sinon prend ceux par défaut
      if (this.content.type == 'numerique') {
        return 'numeric';
      }
      if (this.content.type == 'monetaire') {
        return 'monetaire';
      }
      if (this.content.type == 'heure') {
        return 'compteValidation:heure';
      }
      return 'required|compteValidation:alphaNumeriqueSansEspace';
    },
    reglesAutre() {
      // cas limite bien jouer
      console.log(this.content.validationAutre);
      if (this.content.type == 'number') {
        return this.content.validationAutre;
      }
      // voir si cette condition 'this.optionChoisi' est nécessaire
      if (this.optionChoisi == 0) {
        // Validation si composant enfant
        if (this.content.validationAutre) {
          return this.content.validationAutre;
        }
        // Validation lorsque utilisé par Magnolia directement
        // Si règles définies dans Magnolia
        if (this.content.options.reglesAutre) {
          return this.content.options.reglesAutre;
        }
        // Sinon prend ceux par défaut
        if (this.content.type == 'numerique') {
          return 'numeric|required';
        }
        if (this.content.type == 'monetaire') {
          return 'monetaire';
        }
        if (this.content.type == 'heure') {
          return 'compteValidation:heure';
        }

        return 'compteValidation:alphaNumerique|required';
      }

      return '';
    },
    classeGroupe() {
      if (this.content.largeurBouton == 'proportionnel') {
        return '';
      }
      return 'w-100';
    },
    typeInput() {
      if (this.content.type == 'heure') {
        return 'time';
      }
      if (this.content.type == 'number') {
        return 'number';
      }
      return 'text';
    },
  },
  watch: {
    // fermer tous les formulaires lors du changement d'onglet
    optionChoisi() {
      if (this.selectionAutre) {
        this.$nextTick(() => {
          this.$refs.optionAutre.$el.focus();
        });
      }
    },
  },

  created() {
    console.log(this.content);
    this.optionAutre = 0;
    // TODO: Traiter le cas de "autre". En ce moment la valeur "autre" n'est pas prise en compte
    if (this.content.options) {
      // Bâtir la liste d'options si composant Magnolia
      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(this.content.options)) {
        if (key.includes('options')) {
          if (value.value == null) {
            value.value = 0;
          }
          this.options.push({ text: value.text, value: value.value, name: value.name });
        }
      }
    } else {
      // Options lorsque appelé dans un autre composant
      this.options = this.content.optionsInfo;
    }
  },

  mounted() {
    if (this.content.type == 'monetaire') {
      this.valeurChoix = -1;
    }
    if (this.content.type == 'number') {
      this.valeurChoix = -1;
    }

    this.variablesRemplacement.limiteMinDepotHebdo = process.env.VUE_APP_MIN_LIMITE_DEPOT_HEBDO
      ? formatNombreEnMonetaire(process.env.VUE_APP_MIN_LIMITE_DEPOT_HEBDO, 0)
      : formatNombreEnMonetaire(0, 0);
    this.variablesRemplacement.limiteMaxDepotHebdo = process.env.VUE_APP_MAX_LIMITE_DEPOT_HEBDO
      ? formatNombreEnMonetaire(process.env.VUE_APP_MAX_LIMITE_DEPOT_HEBDO, 0)
      : formatNombreEnMonetaire(0, 0);
  },

  methods: {
    validateChange() {
      this.$refs.validator.validate();
    },
    forceValidate() {
      this.$refs.validator.validate();
      if (this.optionChoisi === 0) {
        this.optionAutre = this.optionAutre ?? 0;

        this.$store.commit('compte/SET_LIMITE_MAX_DEPOT', this.optionAutre);
        this.$store.commit(
          'compte/SET_LIMITE_MAX_DEPOT_AFFICHAGE',
          formatNombreEnMonetaire(this.optionAutre, 0)
        );
      }
    },
    // Validation dedier au limite de jeux - bien Jouer
    async forceValidateInput() {
      const isValid = await this.$refs.validator.validate();
      console.log(`isValid=${isValid}`);
      if (isValid?.valid === true) {
        // n'émet que si c'est valide
        this.optionChoisi = this.optionAutre;
      }
    },
    envoiInfo() {
      if (this.selectionAutre) {
        // Envoi lorsque option autre est sélectionée
        this.valeurChoix = this.optionAutre;
      } else if (this.optionChoisi != 0) {
        // Envoi lorsque option de base
        this.valeurChoix = this.optionChoisi;
      }
    },
    getValidationState({ validated, valid = null }) {
      // Uniquement si la validation a été effectuée une fois et que le champ est invalide
      this.validated = validated;
      if (validated && !valid) {
        return valid;
      }
      if (validated && valid) {
        this.validated = true;
        this.envoiInfo();
      }
      return null;
    },
    customValidation(context) {
      // L'appel vers la règle de validation se faisait à chaque fois que le champ subissait un changement
      // Ceci permet d'appeler la validation seulement lorsqu'on quitte le champ
      // Dans LimiteDepot un @blur est utilisé dans l'element money

      return { on: ['blur'] };
    },
  },
};
</script>

<style lang="scss" scoped>
input:checked + .tableau {
  background-color: $couleur-text-bien-jouer;
  color: $couleur-blanc;
}
.tableau {
  border-color: $couleur-text-bien-jouer;
  border-style: solid;
  border-width: 1px 1px 1px 0;
  padding: 10px 0;
  width: 100%;
  &.premier {
    border-left: 1px solid $couleur-text-bien-jouer;
    border-radius: 10px 0 0 10px;
  }
  &.dernier {
    border-radius: 0 10px 10px 0;
  }
}
.is-valid {
  border-color: $couleur-primaire;
}

.is-invalid {
  border-color: $couleur-erreur;
}

// Style de transitions
.fade-enter-active {
  transition: opacity 0.5s;
}

.fade-enter {
  opacity: 0;
}

.fade-leave-to {
  opacity: 0;
}

.groupe {
  width: auto;
}

.blanc-bg {
  background-color: $couleur-blanc;
}

.ligne {
  width: fit-content;
  display: flex;
  margin: auto;
}
.label-input {
  margin-bottom: 0;
  &:not(.tableau) {
    padding: 0.25rem 4rem 0.25rem 0.75rem;
  }
}
.form-control-limite {
  display: flex;
  width: 7.625rem;
  height: 2.5rem;
  padding: 0.5rem;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  gap: 0.5rem;
  border-radius: 0.125rem;
  border: 1px solid #2d2d2d;
  background: #f2f7fc;
}
.input-group-limite {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.5rem;
}
.input-group-append-limite {
  font-size: 0.9375rem;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* 1.3125rem */
}
.info-lib-msg {
  margin-top: 0.75rem;
  font-size: 15px;
  line-height: 17px;
  text-align: justify;
}
.en {
  .info-lib-msg {
    text-align: end;
  }
}
/* Cibler spécifiquement votre structure */
.row.mx-0 > .col:first-child {
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
  overflow: hidden;
}

.row.mx-0 > .col:last-child {
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
  overflow: hidden;
}

/* Appliquer aussi aux labels pour cohérence */
.row.mx-0 > .col:first-child .label-input {
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
}

.row.mx-0 > .col:last-child .label-input {
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
}
</style>
